@import (reference) 'ui-components/components/text/text.module.less';
@import (reference) '../../../constants/spacing.module.less';

.field {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
}

.field-label {
  color: var(--default--text-color--17);
}

.readonly-value {
  .paragraph();
  color: var(--default--text-color--16);
  min-height: 0;
}

.file-a-claim-link {
  margin-left: 6px;
}

.file-a-claim-icon {
  height: 10px;
  margin-left: @space-4;
  color: var(--primary--icon--fill-color--2);
}
